module.exports = "/img/cj-hol_bg_mobile.png?655ecaa294c5b09c45654e874e14d62e";